import LMSDispatcher from "../LMSDispatcher";

import * as CONSTANTS from "../../utilities/Constants";

import INavigationHeaderData from "../../models/shared/NavigationHeaderData";

class NavigationHeaderActions {

    async updateHeader(data: INavigationHeaderData) {
        LMSDispatcher.dispatch({
            type: CONSTANTS.UPDATE_NAVIGATION_HEADER,
            payload: data
        });
    }
}

const navigationHeaderActions = new NavigationHeaderActions();
export default navigationHeaderActions;